import React from 'react';
import { connect } from 'react-redux';

import MediaSelectModal from './MediaSelectModal';

const mapStateToProps = (state, ownProps) => ({
    media: ownProps.media ? ownProps.media : Object.values(state.media),
});

const mapDispatchToProps = {

};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MediaSelectModal);
